import { render, staticRenderFns } from "./mFooter.vue?vue&type=template&id=ec813710&"
import script from "./mFooter.vue?vue&type=script&lang=js&"
export * from "./mFooter.vue?vue&type=script&lang=js&"
import style0 from "./mFooter.vue?vue&type=style&index=0&id=ec813710&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports